import React, { useRef, useEffect } from 'react';
import { nanoid } from 'nanoid/non-secure';
const getName = Component => Component && Component.constructor && Component.constructor.name || 'dsId';
const generateId = Component => {
  const componentName = getName(Component);
  const randomId = nanoid(10);
  return `${componentName}_${randomId}`;
};
export const useId = id => {
  // В React 18 появился useId, который возвращает одинаковый результат на клиенте и при SSR
  const reactId = React.useId == null ? void 0 : React.useId();
  const idRef = useRef(id || reactId);
  useEffect(() => {
    // Если id не передан снаружи, и используется React < 18, то генерируем id только на клиенте
    if (!idRef.current) {
      idRef.current = generateId();
    }
  }, []);
  return idRef.current;
};
export default generateId;